
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map-fluency",
      function () {
        return require("private-next-pages/map-fluency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map-fluency"])
      });
    }
  